// eslint-disable-next-line import/no-named-as-default
import NodeCache from 'node-cache';

import { DEFAULT_CACHE_TIMEOUT } from '../constants/cache';

export class CacheUtils {
  private cache: NodeCache | undefined;

  private generateCache() {
    this.cache = new NodeCache({
      stdTTL: DEFAULT_CACHE_TIMEOUT,
    });
  }

  public getCachedData<T>(key: string) {
    if (!this.cache) {
      this.generateCache();

      return undefined;
    }

    return this.cache.get<T>(key);
  }

  public setCachedData<T>(key: string, value: T) {
    if (!this.cache) {
      this.generateCache();
    }

    (this.cache as NodeCache).set<T>(key, value);
  }
}

export const cacheUtils = new CacheUtils();
